import {Cities} from './Cities';

var States = Object.keys(Cities);

export default States